export default __webpack_public_path__ + "static/media/strahlenprofil.4a4b8d1f.svg";